// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3qgU4","file":"styles_file__2yMs0"};